<!--  -->
<template>
    <div class="quickPay">

        <div class="payBg">
            <img src="@/assets/images/pay/payBg.png" alt="" />
            <div class="parkName">{{paymentCodeDetail.merchantName}}</div>
            <span class="text">为您代付停车费</span>
        </div>
        <!-- <Swipe :areaType="3" :singleImg="singleImg" :className="`quickPay-header-image`"></Swipe> -->
        <div class="quickPay-wrap">
            <div class="quickPay-type flex justify-between">
                <div class="quickPay-type-item" v-for="(item, index) in carTypeList" :key="index" @click="changeType(item)">
                    <p v-if="index < 2" :class="[type == item.type ? 'quickPay-type-item-textA' : 'quickPay-type-item-text', 'flex', 'align-center', 'justify-center']">
                        {{ item.name }} <img v-if="item.type == 3" src="@/assets/images/pay/down.png" alt="" /></p>
                    <p v-if="index == 2" :class="[type >= item.type ? 'quickPay-type-item-textA' : 'quickPay-type-item-text', 'flex', 'align-center', 'justify-center']">
                        {{ item.name }} <img v-if="item.type == 3" src="@/assets/images/pay/down.png" alt="" /></p>
                </div>
            </div>
        </div>

        <div class="quickPay-content">
            <CarKeyboard ref="CarKeyboard" :addType="false" :carNoList.sync="carNoList" :cartype.sync="type" @confirmBtnFn="getResult" :showDefault="false" />

            <!-- <div class="quickPay-tip flex align-center">
                <img src="@/assets/images/pay/pay-tip.png" alt="" />
                <p>付款成功请尽快离场，超时将加收停车费</p>
            </div> -->
            <van-button class="comfirm-btn" v-debounce="searchFee">查询费用</van-button>
        </div>

        <telephonne />
    </div>
</template>

<script>
import CarKeyboard from "@/components/car-keyboard.vue";
import Telephonne from "@/components/telephone";
import Swipe from "@/components/base/swipe.vue";
import { getPaymentCodeDetail, queryParkingRecordPaymentOnBehalf } from '@/api/api'

export default {
    name: 'carFarePayment',
    components: {
        CarKeyboard, Telephonne, Swipe
    },

    data() {
        return {
            singleImg: require('@/assets/images/pay/pay-quick.png'),
            carNoList: ["闽", "C"], //单个车牌号数组
            plateNum: '',//车牌号
            oldType: "", //老的type
            type: 1,
            carTypeList: [
                {
                    name: "蓝牌",
                    type: 1,
                },
                {
                    name: "绿牌",
                    type: 2,
                },

            ],

            query: {},
            paymentCodeDetail: {}
        };
    },

    computed: {},

    mounted() {
        let { paymentCode: code, type } = this.$route.query;
        getPaymentCodeDetail({ code, type }).then(res => {
            if (res.data) {
                this.paymentCodeDetail = res.data

            }
            else {
                this.$toast('代付码无效')
            }

        }).catch(err => {
            this.$toast('代付码无效')
        })
    },

    methods: {
        // 车牌颜色改变事件
        changeType(item) {
            //有键盘时不能修改类型
            if (this.$refs.CarKeyboard.show_keyboard) return;
            this.oldType = this.type;
            this.type = item.type;

        },

        getResult(data, isDefault, isSearch) {
            this.plateNum = data;
            if (isSearch) {
                this.searchFee();
            }
        },
        searchFee() {
            queryParkingRecordPaymentOnBehalf({ plateNum: this.plateNum, parkCode: this.paymentCodeDetail.parkCode, code: this.$route.query.paymentCode, type: this.$route.query.type }).then(res => {
                if (res.data.length == 0) {
                    this.$toast('暂无停车记录')
                }
                else {
                    this.$router.push({
                        path: '/carFarePayment/paymentParkingRecords',
                        query: {
                            plateNum: this.plateNum,
                            parkCode: this.paymentCodeDetail.parkCode,
                            code: this.$route.query.paymentCode,
                            type: this.$route.query.type,
                            limitMoney: this.paymentCodeDetail.limitMoney
                        }

                    })
                }
            })
        }
    }
}

</script>
<style lang='less' scoped>
.payBg {
    position: relative;
    background-color: #fff;
    img {
        width: 100%;
    }
    .parkName {
        font-size: 40px;
        line-height: 40px;
        position: absolute;
        width: 300px;
        left: 50%;
        margin-left: -150px;
        top: 200px;
        color: rgb(2, 113, 217);
        text-align: center;
    }

    .text {
        font-size: 32px;
        position: absolute;
        width: 300px;
        left: 50%;
        margin-left: -150px;
        top: 270px;
        color: rgb(0, 33, 87);
        text-align: center;
    }
}

.quickPay {
    /deep/ .quickPay-header-image {
        width: 750px;
        height: 200px;
    }

    .quickPay-wrap {
        background: #fff;
        padding: 15px 0;

        .quickPay-type {
            width: 702px;
            height: 64px;
            border: 1px solid #dbdada;
            border-radius: 16px;
            margin: 0 auto;

            .quickPay-type-item {
                height: 100%;
                flex: 1;

                .quickPay-type-item-text {
                    font-size: 28px;
                    color: #666666;
                    text-align: center;
                    line-height: 64px;
                    position: relative;

                    &::before {
                        content: "";
                        width: 1px;
                        height: 40px;
                        position: absolute;
                        background-color: #dbdada;
                        top: 12px;
                        left: 0;
                    }
                }

                &:nth-child(1) {
                    .quickPay-type-item-text {
                        position: relative;

                        &::before {
                            content: "";
                            width: 0;
                        }
                    }
                }

                .quickPay-type-item-textA {
                    font-size: 28px;
                    height: 100%;
                    line-height: 64px;
                    color: #fff;
                    text-align: center;
                    background-image: linear-gradient(
                        90deg,
                        #009af3 0%,
                        #00c6ea 100%
                    );
                    border-radius: 15px;
                }

                img {
                    width: 12px;
                    height: 8px;
                    margin-left: 10px;
                }
            }
        }
    }

    .quickPay-content {
        padding: 24px;
        background-color: #fff;

        .quickPay-code-list {
            width: 702px;
            min-height: 204px;
            background: #009af31a;
            border-radius: 16px;
            padding: 24px;

            .quickPay-code-history {
                font-size: 30px;
                color: #212121;
                margin-bottom: 23px;
            }

            .quickPay-code-wrap {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;

                // overflow-x: scroll;
                &:after {
                    content: "";
                    width: 302px; //这个宽度和子元素宽度一致
                    height: 0;
                    display: block;
                }

                .quickPay-code-item-green {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;
                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-green.png")
                        no-repeat;
                    color: #110b0d;
                }

                .quickPay-code-item-blue {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-blue.png")
                        no-repeat;
                    color: #fff;
                }

                .quickPay-code-item-yellow {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-yellow.png")
                        no-repeat;
                    color: #110b0d;
                }

                .quickPay-code-item-temp {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-temp.png")
                        no-repeat;
                    color: #110b0d;
                }

                .quickPay-code-item-black {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-black.png")
                        no-repeat;
                    color: #fff;
                }

                .quickPay-code-item-white {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-white.png")
                        no-repeat;
                    color: #110b0d;
                }

                .quickPay-code-item-yellow-green {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-yellow-green.png")
                        no-repeat;
                    color: #110b0d;
                }

                .quickPay-code-item {
                    height: 88px;
                    position: relative;
                    flex-shrink: 0;
                    background-size: 100% 100%;
                    margin-right: 16px;

                    .code-item-number {
                        white-space: nowrap;

                        line-height: 88px;
                        text-align: center;
                    }

                    .quickPay-code-itemA {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        left: 0;
                        top: 0;
                        background: #009af3cc;
                        border-radius: 8px;

                        img {
                            position: absolute;
                            width: 48px;
                            height: 48px;
                            left: 0;
                            right: 0;
                            top: 0;
                            bottom: 0;
                            margin: auto;
                        }
                    }
                }
            }
        }

        .quickPay-tip {
            margin-top: 70px;

            img {
                width: 24px;
                height: 24px;
            }

            p {
                font-size: 26px;
                color: #616161;
                margin-left: 8px;
            }
        }
    }

    .content-other {
        .content-other-itemA {
            width: 702px;
            height: 64px;
            background: #009af333;
            border-radius: 16px;
            margin: 0 22px;

            p {
                color: #009af3;
                line-height: 64px;
                text-align: center;
            }
        }

        .content-other-item {
            width: 702px;
            height: 64px;
            // background: #009AF333;
            border-radius: 16px;
            margin: 0 22px;

            p {
                color: #666666;
                line-height: 64px;
                text-align: center;
            }
        }

        .content-other-btn {
            width: 750px;
            padding: 22px;

            .content-btn {
                width: 343px;
                height: 70px;
                border-radius: 16px;
            }
        }
    }
}
</style>